var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21428_72353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11035 14.3203V11.8203H6.61035C6.09082 11.8203 5.67285 11.4023 5.67285 10.8828C5.67285 10.3633 6.09082 9.94531 6.61035 9.94531H9.11035V7.44531C9.11035 6.92578 9.52832 6.50781 10.0479 6.50781C10.5674 6.50781 10.9854 6.92578 10.9854 7.44531V9.94531H13.4854C14.0049 9.94531 14.4229 10.3633 14.4229 10.8828C14.4229 11.4023 14.0049 11.8203 13.4854 11.8203H10.9854V14.3203C10.9854 14.8398 10.5674 15.2578 10.0479 15.2578C9.52832 15.2578 9.11035 14.8398 9.11035 14.3203ZM20.0479 10.8828C20.0479 16.4062 15.5713 20.8828 10.0479 20.8828C4.52441 20.8828 0.0478516 16.4062 0.0478516 10.8828C0.0478516 5.35938 4.52441 0.882812 10.0479 0.882812C15.5713 0.882812 20.0479 5.35938 20.0479 10.8828ZM10.0479 2.75781C5.55957 2.75781 1.92285 6.39453 1.92285 10.8828C1.92285 15.3711 5.55957 19.0078 10.0479 19.0078C14.5361 19.0078 18.1729 15.3711 18.1729 10.8828C18.1729 6.39453 14.5361 2.75781 10.0479 2.75781Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21428_72353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0478516 0.882812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedia);
export default __webpack_public_path__ + "static/media/addMedia.18bf2156940397a4d041fd3f62157cf6.svg";
export { ForwardRef as ReactComponent };